import { useQuery } from '@tanstack/react-query';

import { type User } from '@/types/user';
import { domainMeta } from '@/utils/domain-meta';

const fetchWhoami = async (): Promise<User | null> => {
  const res = await fetch(
    `${domainMeta.monolithOrigin}/api_self_serve/v1/whoami`,
    { credentials: 'include' },
  );

  if (res.status === 401) return null;
  if (!res.ok) throw new Error('Failed to fetch user');

  const data = (await res.json()) as User;
  return data;
};

export const useAuth = () => {
  return useQuery({
    queryKey: ['whoami'],
    queryFn: fetchWhoami,
    retry: false,
  });
};
